import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import { globalAction } from '../../../../../../../store/action';
import { globalStateSelector } from '../../../../../../../store/selector';

const CheckboxWithLabel = (props) => {
  const {
    permissionAccessDefination,
    tenantAccessDefination,
    permissionType,
    className,
    dynamicUpdate,
    type,
    id,
    optionKey,
    disabled,
    text,
  } = props;

  let permissions =
    permissionType === 'tenant'
      ? tenantAccessDefination
      : permissionAccessDefination;

  let newPermissions, value;

  if (type === 'header') {
    value = permissions[id].headerOptions[optionKey];
  } else {
    value = permissions[id].options[optionKey];
  }
  let newValue = !value;

  const setHeaderOptionsAsPerBody = (id, options) => {
    let newHeaderValue = false;
    if (permissions[id].headerOptions) {
      Object.keys(options).map((e) => {
        if (options[e] === true) {
          newHeaderValue = true;
          return;
        }
      });
      permissions[id].headerOptions['allow-view'] = newHeaderValue;
    }
  };

  const setOptions = () => {
    let newOptions = permissions[id].options;
    newOptions[optionKey] = newValue;
    let optionsKeysArray = Object.keys(newOptions);

    if (optionKey === 'all') {
      if (permissions[id].headerOptions) {
        permissions[id].headerOptions['allow-view'] = newValue;
      }
      optionsKeysArray.map((e) => {
        newOptions[e] = newValue;
      });
    } else if (optionKey === 'list' && newValue === false) {
      optionsKeysArray.map((e) => {
        newOptions[e] = false;
      });
    } else {
      let newallOptionValue;
      for (let e = 0; e < optionsKeysArray.length; e++) {
        if (optionsKeysArray[e] === 'all') {
          continue;
        }
        const optionValue = newOptions[optionsKeysArray[e]];
        if (optionValue === false) {
          newallOptionValue = false;
          break;
        } else if (optionValue === true) {
          newallOptionValue = true;
        }
      }

      if (newValue === true && newOptions.hasOwnProperty('list')) {
        newOptions['list'] = true;
      }
      if (newOptions.hasOwnProperty('all')) {
        newOptions['all'] = newallOptionValue;
      }
    }

    setHeaderOptionsAsPerBody(id, permissions[id].options);
    return newOptions;
  };

  const setBodyOptionsAsPerHeader = (options) => {
    return Object.keys(options).map((e) => {
      options[e] = newValue;
    });
  };

  const onChange = () => {
    if (type === 'header') {
      newPermissions = {
        ...permissions,
        [id]: {
          ...permissions[id],
          headerOptions: {
            ...permissions[id].headerOptions,
            [optionKey]: newValue,
          },
        },
      };
      if (newPermissions[id].options) {
        setBodyOptionsAsPerHeader(newPermissions[id].options);
      }
    } else {
      newPermissions = {
        ...permissions,
        [id]: {
          ...permissions[id],
          options: setOptions(),
        },
      };
    }

    dynamicUpdate({
      key:
        permissionType === 'admin'
          ? 'permissionAccessDefination'
          : 'tenantAccessDefination',
      value: newPermissions,
    });
  };

  return (
    <div className={`checkbox-wrapper ${className ? className : ''}`}>
      <label>
        <input
          type='checkbox'
          disabled={disabled}
          onChange={onChange}
          className={`${disabled} ${
            value === true ? 'checked' : 'not-checked'
          }`}
        />
        <span className='capitalize checkbox-label'>
          {text.replaceAll('-', ' ')}
        </span>
      </label>
    </div>
  );
};

const stateToProps = (state) => ({
  permissionAccessDefination: globalStateSelector.getDynamic(state, {
    key: 'permissionAccessDefination',
  }),
  tenantAccessDefination: globalStateSelector.getDynamic(state, {
    key: 'tenantAccessDefination',
  }),
  permissionType: globalStateSelector.getDynamic(state, {
    key: 'permissionType',
  }),
});

const dispatchToProps = (dispatch) => ({
  dynamicUpdate: (data) => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
});

export default connect(stateToProps, dispatchToProps)(CheckboxWithLabel);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CommonPermission/CheckboxWithLabel/index.jsx